import { Inject, Injectable } from '@angular/core';
import { extend, isError } from 'lodash';

@Injectable()
export class ErrorToaster {
  constructor(@Inject('$mdToast') private $mdToast, @Inject('Rollbar') private Rollbar) {}

  showError(err) {
    this.$mdToast.show(this.$mdToast.simple().textContent(this._messageFromError(err))).catch(err => {
      if (err) this.Rollbar.warning(err);
      this.Rollbar.warning('Failed to show toast');
    });
  }

  private _processJsError(err) {
    return err.name + '\n' + err.message;
  }

  private _process$HttpError(err) {
    return err.status + ' ' + err.statusText + '\n';
  }

  private _messageFromError(err) {
    if (isError(err)) {
      return this._processJsError(err);
    } else if (err.status && err.statusText) {
      return this._process$HttpError(err);
    } else if (err.status === -1) {
      // Network issues
      return this._process$HttpError(extend(err, { statusText: 'Request has timedout' }));
    }
  }
}
